(function () {
  "use strict";

  // ============ SCROLL REVEAL ============
  function initScrollReveal() {
    var tagMap = [
      [".problem-card", "reveal-up", 100],
      [".how-step", "reveal-up", 120],
      [".review", "reveal-up", 80],
      [".solution-features li", "reveal-left", 80],
      [".bundle", "reveal-up", 80],
      [".showcase-item", "reveal-scale", 100],
      [".compare-row:not(.head)", "reveal-up", 40],
      [".faq-item", "reveal-up", 40],
      [".og-item", "reveal-up", 60],
      [".rs-item", "reveal-up", 80],
    ];
    tagMap.forEach(function (entry) {
      var selector = entry[0], className = entry[1], stagger = entry[2];
      document.querySelectorAll(selector).forEach(function (el, i) {
        el.classList.add(className);
        el.style.transitionDelay = (i * stagger) + "ms";
      });
    });
    if (!("IntersectionObserver" in window)) {
      document.querySelectorAll(".reveal-up, .reveal-left, .reveal-scale").forEach(function (el) { el.classList.add("visible"); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add("visible"); io.unobserve(e.target); }
      });
    }, { threshold: 0.1, rootMargin: "0px 0px -60px 0px" });
    document.querySelectorAll(".reveal-up, .reveal-left, .reveal-scale").forEach(function (el) { io.observe(el); });
  }

  // ============ COUNTDOWN ============
  function initCountdown() {
    var bar = document.querySelector("[data-countdown]");
    if (!bar) return;
    var hEl = bar.querySelector("[data-cd-h]");
    var mEl = bar.querySelector("[data-cd-m]");
    var sEl = bar.querySelector("[data-cd-s]");
    var endKey = "pw_offer_end_v5";
    var OFFER_DURATION_MS = (23 * 3600 + 47 * 60 + 12) * 1000;
    var end = 0;
    try { end = parseInt(sessionStorage.getItem(endKey) || "0", 10); } catch (e) {}
    if (!end || end < Date.now()) {
      end = Date.now() + OFFER_DURATION_MS;
      try { sessionStorage.setItem(endKey, String(end)); } catch (e) {}
    }
    function pad(n) { return String(n).padStart(2, "0"); }
    function tick() {
      var diff = Math.max(0, end - Date.now());
      if (diff === 0 && bar) { bar.style.display = "none"; return; }
      var hh = Math.floor(diff / 3600000);
      var mm = Math.floor((diff % 3600000) / 60000);
      var ss = Math.floor((diff % 60000) / 1000);
      if (hEl) hEl.textContent = pad(hh);
      if (mEl) mEl.textContent = pad(mm);
      if (sEl) sEl.textContent = pad(ss);
    }
    tick();
    setInterval(tick, 1000);
  }

  // ============ CART DRAWER ============
  function formatMoney(cents) {
    return "$" + (cents / 100).toFixed(2);
  }

  function openCartDrawer() {
    var drawer  = document.getElementById("cartDrawer");
    var overlay = document.getElementById("cartOverlay");
    if (!drawer) return;
    drawer.classList.add("open");
    if (overlay) overlay.classList.add("open");
    document.body.style.overflow = "hidden";
    refreshCartDrawer();
  }

  function closeCartDrawer() {
    var drawer  = document.getElementById("cartDrawer");
    var overlay = document.getElementById("cartOverlay");
    if (drawer) drawer.classList.remove("open");
    if (overlay) overlay.classList.remove("open");
    document.body.style.overflow = "";
  }

  function refreshCartDrawer() {
    fetch("/cart.js", { headers: { "Accept": "application/json" } })
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        renderCartDrawer(cart);
        updateCartCounts(cart.item_count);
      })
      .catch(function() {});
  }

  function updateCartCounts(count) {
    var counters = document.querySelectorAll(".nav-cart-count, .cart-count, .header__cart-count, [data-cart-count]");
    counters.forEach(function(el) {
      el.textContent = count;
      el.style.display = count > 0 ? "" : "none";
    });
  }

  function renderCartDrawer(cart) {
    var body   = document.getElementById("cartDrawerBody");
    var footer = document.getElementById("cartDrawerFooter");
    var sub    = document.getElementById("cartDrawerSubtotal");
    if (!body) return;

    if (!cart.items || cart.items.length === 0) {
      body.innerHTML = '<div class="cart-drawer-empty"><p>Your cart is empty.</p><a href="#buy">Choose a pack</a></div>';
      if (footer) footer.style.display = "none";
      return;
    }

    var html = "";
    cart.items.forEach(function(item) {
      var img = item.image ? '<img src="' + item.image + '" alt="' + item.title + '">' : '';
      html += '<div class="cart-item">' +
        '<div class="cart-item-img">' + img + '</div>' +
        '<div class="cart-item-info">' +
          '<div class="cart-item-title">' + item.product_title + '</div>' +
          '<div class="cart-item-variant">' + (item.variant_title !== "Default Title" ? item.variant_title : "Qty: " + item.quantity) + '</div>' +
          '<div class="cart-item-price">' + formatMoney(item.final_line_price) + '</div>' +
          '<button class="cart-item-remove" data-key="' + item.key + '">Remove</button>' +
        '</div>' +
      '</div>';
    });

    body.innerHTML = html;

    body.querySelectorAll(".cart-item-remove").forEach(function(btn) {
      btn.addEventListener("click", function() {
        var key = btn.getAttribute("data-key");
        fetch("/cart/change.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ id: key, quantity: 0 })
        })
        .then(function(r) { return r.json(); })
        .then(function(updatedCart) {
          renderCartDrawer(updatedCart);
          updateCartCounts(updatedCart.item_count);
        });
      });
    });

    if (footer) footer.style.display = "";
    if (sub) sub.textContent = formatMoney(cart.total_price);
  }

  function initCartDrawer() {
    var overlay  = document.getElementById("cartOverlay");
    var closeBtn = document.getElementById("cartDrawerClose");
    var cartIcon = document.querySelector(".nav-cart");

    if (overlay)  overlay.addEventListener("click", closeCartDrawer);
    if (closeBtn) closeBtn.addEventListener("click", closeCartDrawer);

    if (cartIcon) {
      cartIcon.addEventListener("click", function(e) {
        e.preventDefault();
        openCartDrawer();
      });
    }

    document.addEventListener("keydown", function(e) {
      if (e.key === "Escape") closeCartDrawer();
    });
  }

  // ============ BUNDLE SELECTOR + CART ============
  var BUNDLES = {
    "1": { variantId: null, label: "Starter Pack",   price: null },
    "2": { variantId: null, label: "Household Pack", price: null },
    "3": { variantId: null, label: "Family Pack",    price: null }
  };

  var selectedBundle = "2";

  function initBundleSelector() {
    var cards = document.querySelectorAll("[data-bundle]");
    var btn   = document.getElementById("pw-atc-btn");
    var label = document.getElementById("pw-atc-label");
    if (!cards.length || !btn) return;

    BUNDLES["1"].variantId = btn.getAttribute("data-variant-1") || "";
    BUNDLES["2"].variantId = btn.getAttribute("data-variant-2") || "";
    BUNDLES["3"].variantId = btn.getAttribute("data-variant-3") || "";
    BUNDLES["1"].price = parseFloat(btn.getAttribute("data-price-1") || "59");
    BUNDLES["2"].price = parseFloat(btn.getAttribute("data-price-2") || "89");
    BUNDLES["3"].price = parseFloat(btn.getAttribute("data-price-3") || "119");

    function select(key) {
      selectedBundle = key;
      var b = BUNDLES[key];
      cards.forEach(function(card) {
        var active = card.getAttribute("data-bundle") === key;
        card.classList.toggle("active", active);
        card.setAttribute("aria-pressed", active);
      });
      if (label) label.textContent = "Add To Cart \u2014 $" + b.price.toFixed(2);
      var wasPrices = { "1": 118, "2": 178, "3": 238 };
      var sLabel = document.querySelector("[data-sticky-label]");
      var sWas   = document.querySelector("[data-sticky-was]");
      var sNow   = document.querySelector("[data-sticky-now]");
      var sBtnL  = document.querySelector("[data-sticky-btn-long]");
      var sBtnS  = document.querySelector("[data-sticky-btn-short]");
      if (sLabel) sLabel.textContent = "PureWave " + b.label;
      if (sWas)   sWas.textContent   = "$" + wasPrices[key];
      if (sNow)   sNow.textContent   = "$" + b.price + " USD";
      if (sBtnL)  sBtnL.textContent  = "Add to Cart \u00B7 $" + b.price;
      if (sBtnS)  sBtnS.textContent  = "Buy $" + b.price;
    }

    cards.forEach(function(card) {
      card.addEventListener("click", function() {
        var key = card.getAttribute("data-bundle");
        if (key) select(key);
      });
    });

    btn.addEventListener("click", function() {
      var b = BUNDLES[selectedBundle];
      var feedback = document.getElementById("pw-atc-feedback");

      if (!b.variantId) {
        if (feedback) {
          feedback.textContent = "Setup required: add variant IDs in theme settings.";
          feedback.className = "atc-feedback atc-error";
        }
        return;
      }

      btn.disabled = true;
      btn.classList.add("loading");
      if (label) label.textContent = "Adding\u2026";
      if (feedback) { feedback.textContent = ""; feedback.className = "atc-feedback"; }

      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", "Accept": "application/json" },
        body: JSON.stringify({
          id: parseInt(b.variantId, 10),
          quantity: 1,
          properties: { "_pack": b.label }
        })
      })
      .then(function(res) {
        if (!res.ok) { return res.json().then(function(e) { throw e; }); }
        return res.json();
      })
      .then(function() {
        if (label) label.textContent = "Added \u2714";
        if (feedback) { feedback.textContent = ""; feedback.className = "atc-feedback"; }
        btn.classList.remove("loading");
        btn.classList.add("success");
        openCartDrawer();
        setTimeout(function() {
          if (label) label.textContent = "Add To Cart \u2014 $" + b.price.toFixed(2);
          btn.disabled = false;
          btn.classList.remove("success");
        }, 3000);
      })
      .catch(function(err) {
        var msg = (err && err.description) ? err.description : "Something went wrong. Please try again.";
        if (label) label.textContent = "Add To Cart \u2014 $" + b.price.toFixed(2);
        if (feedback) {
          feedback.textContent = msg;
          feedback.className = "atc-feedback atc-error";
        }
        btn.disabled = false;
        btn.classList.remove("loading");
      });
    });

    select(selectedBundle);
  }

  // ============ STICKY CART ============
  function initStickyCart() {
    var bar = document.querySelector("[data-sticky-cart]");
    if (!bar) return;
    function onScroll() { bar.classList.toggle("visible", window.scrollY > 520); }
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
  }

  // ============ LIVE NOTIFICATIONS ============
  var purchases = [
    { name: "Sarah",   city: "Austin, TX",    product: "Household Pack", time: "12 minutes ago" },
    { name: "Michael", city: "Chicago, IL",   product: "Family Pack",    time: "8 minutes ago"  },
    { name: "Emma",    city: "Denver, CO",    product: "Starter Pack",   time: "5 minutes ago"  },
    { name: "Jake",    city: "Seattle, WA",   product: "Household Pack", time: "3 minutes ago"  },
    { name: "Lauren",  city: "Phoenix, AZ",   product: "Family Pack",    time: "1 minute ago"   },
    { name: "Ryan",    city: "Nashville, TN", product: "Household Pack", time: "just now"       },
    { name: "Olivia",  city: "Portland, OR",  product: "Starter Pack",   time: "4 minutes ago"  },
    { name: "Marcus",  city: "San Diego, CA", product: "Family Pack",    time: "7 minutes ago"  }
  ];

  function initLiveNotif() {
    var notif = document.querySelector("[data-live-notif]");
    if (!notif) return;
    var avatar = notif.querySelector("[data-live-avatar]");
    var text   = notif.querySelector("[data-live-text]");
    var idx = 0;
    function show() {
      var p = purchases[idx % purchases.length];
      if (avatar) avatar.textContent = p.name[0];
      if (text) text.innerHTML =
        "<b>" + p.name + " from " + p.city + "</b><br>" +
        "<span style=\"color:#6a6b72\">ordered the " + p.product + "</span><br>" +
        "<span style=\"color:#9a9ba0;font-size:11px\">" + p.time + "</span>";
      notif.classList.add("show");
      setTimeout(function () { notif.classList.remove("show"); }, 4500);
      idx++;
    }
    setTimeout(function () { show(); setInterval(show, 12000); }, 6000);
  }

  // ============ DISCLAIMER STYLES ============
  function addDisclaimerStyles() {
    var style = document.createElement("style");
    style.textContent = [
      ".offer-disclaimer{margin-top:20px;font-size:11px;color:var(--muted);line-height:1.7;text-align:center;max-width:680px;margin-inline:auto;padding:0 16px;}",
      ".footer-disclaimer-full{font-size:11px;color:var(--muted);line-height:1.8;text-align:center;padding:20px 0 12px;border-top:1px solid var(--border);margin-top:32px;max-width:700px;margin-inline:auto;}"
    ].join("");
    document.head.appendChild(style);
  }

  function init() {
    addDisclaimerStyles();
    initScrollReveal();
    initCountdown();
    initCartDrawer();
    initBundleSelector();
    initStickyCart();
    initLiveNotif();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();